import React from "react";
import makeStyles from "@mui/styles/makeStyles";

import { Box } from "@mui/material";
import Grid from "@mui/material/Grid";
import { join } from "ramda";

const useStyles = makeStyles(theme => ({
  labelAndValue: {
    "& label": {
      fontWeight: "bold",
      paddingRight: theme.spacing(2),
    },
  },
}));

const BarcodeAuthenticationCell = props => {
  const { authentication } = props;
  const classes = useStyles();

  return (
    <Grid container spacing={1}>
      <Grid item sm={12}>
        <Box className={classes.labelAndValue}>
          <label>Barcode Prefixes:</label>
          {join(", ", authentication.prefixes)}
        </Box>
      </Grid>
    </Grid>
  );
};

export default BarcodeAuthenticationCell;
